import { useEffect, useState } from 'react'

interface RotatingTextProps {
  texts: string[]
  interval?: number
  className?: string
}

const SWAP_MS = 250
const GLITCH_MS = 450

export const RotatingText: React.FC<RotatingTextProps> = ({ texts, interval = 2500, className = '' }) => {
  const [index, setIndex] = useState(0)
  const [visible, setVisible] = useState(true)
  const [glitching, setGlitching] = useState(false)

  useEffect(() => {
    if (texts.length < 2) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    let swap: number | undefined
    let settle: number | undefined
    const tick = window.setInterval(() => {
      setVisible(false)
      swap = window.setTimeout(() => {
        setIndex((i) => (i + 1) % texts.length)
        setVisible(true)
        setGlitching(true)
        settle = window.setTimeout(() => setGlitching(false), GLITCH_MS)
      }, SWAP_MS)
    }, interval)

    return () => {
      window.clearInterval(tick)
      window.clearTimeout(swap)
      window.clearTimeout(settle)
    }
  }, [texts.length, interval])

  return (
    <p
      data-testid="tagline"
      data-text={texts[index]}
      data-glitch={glitching ? 'true' : undefined}
      className={`glitch-text relative h-6 whitespace-nowrap text-[10px] tracking-[0.16em] md:text-xs md:tracking-[0.25em] uppercase text-white/75 [text-shadow:0_1px_2px_rgba(0,0,0,0.95),0_0_16px_rgba(0,0,0,0.9),0_0_32px_rgba(0,0,0,0.7)] transition-opacity duration-250 ease-out ${
        visible ? 'opacity-100' : 'opacity-0'
      } ${className}`}
    >
      {texts[index]}
    </p>
  )
}
